export default __webpack_public_path__ + "28bd1952ba29ca7f50bcbc7780a01eda.png";